'use client';

import {Footer as DefaultFooter} from '../default-footer';

import styles from './team-plan-footer.module.scss';
import classNames from 'classnames';
import {LanguageSelectorButton, SelectorLocation} from '@udemy-v2/react-language-selector';
import React from 'react';

export function Footer() {
    return (
        <div className={classNames('ud-color-scheme-dark')}>
            <DefaultFooter />
            <div className={styles['language-row']}>
                <LanguageSelectorButton
                    withLabel={true}
                    selectorLocation={SelectorLocation.Footer}
                    onLocaleChange={() => window.location.reload()}
                />
            </div>
        </div>
    );
}
